"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendLegacySDKEvent = exports.translateLegacyImageStudioEvent = void 0;
const types_1 = require("../types");
const translateLegacyImageStudioEvent = (setUsingLegacyEventFormat, eventData) => {
    if (eventData === null || eventData === void 0 ? void 0 : eventData.connect) {
        if (eventData === null || eventData === void 0 ? void 0 : eventData.newEventFormat) {
            setUsingLegacyEventFormat(false);
            return null;
        }
        else {
            setUsingLegacyEventFormat(true);
            console.warn(`[LEGACY] Reading backwards compatible studio event for type: ${types_1.ImageStudioEventType.Connect}`);
            return {
                type: types_1.ImageStudioEventType.Connect,
                data: {},
            };
        }
    }
    if (eventData === null || eventData === void 0 ? void 0 : eventData.disconnect) {
        setUsingLegacyEventFormat(true);
        console.warn(`[LEGACY] Reading backwards compatible studio event for type: ${types_1.ImageStudioEventType.Disconnect}`);
        return {
            type: types_1.ImageStudioEventType.Disconnect,
            data: {},
        };
    }
    if (eventData === null || eventData === void 0 ? void 0 : eventData.exportImageInfo) {
        setUsingLegacyEventFormat(true);
        console.warn(`[LEGACY] Reading backwards compatible studio event for type: ${types_1.ImageStudioEventType.ImageSave}`);
        return {
            type: types_1.ImageStudioEventType.ImageSave,
            data: { image: eventData.exportImageInfo },
        };
    }
    return null;
};
exports.translateLegacyImageStudioEvent = translateLegacyImageStudioEvent;
const sendLegacySDKEvent = (instanceWindow, event) => {
    if (instanceWindow) {
        switch (event.type) {
            case types_1.SDKEventType.Focus:
                console.warn(`[LEGACY] Sending backwards compatible studio event for type: ${event.type}`);
                instanceWindow.postMessage({ focus: true }, '*');
                break;
            case types_1.SDKEventType.SDKMetadata:
                console.warn(`[LEGACY] Sending backwards compatible studio event for type: ${event.type}`);
                instanceWindow.postMessage({ sdkMetadata: event.data }, '*');
                break;
            case types_1.SDKEventType.ImageInput:
                console.warn(`[LEGACY] Sending backwards compatible studio event for type: ${event.type}`);
                instanceWindow.postMessage({
                    inputImages: event.data.images,
                }, '*');
                break;
            default:
                console.warn(`[LEGACY] Potential broken functionality whilst using old image-studio for event with type: ${event.type}`);
                break;
        }
    }
};
exports.sendLegacySDKEvent = sendLegacySDKEvent;
//# sourceMappingURL=LegacyHelpers.js.map